<app-si-dialog header="Connect HubSpot" #modalComponent modalFooterClasses="si-dialog__footer--centered">
    <ng-template appDialogBody>
        <div class="modal-body p-6">
            <p>Please select which version of our HubSpot integration you would like to connect to.</p>
            <mat-radio-group [(ngModel)]="selectedOption">
                <div>
                    <mat-radio-button name="integrationVersion" id="hubspotContacts" value="hubspotContacts">
                        <p class="mb-0">
                        <b>HubSpot Contacts</b> - Export contact records to HubSpot with Firmographic data on the
                        contact
                        record. If
                        you do not use "Companies" in HubSpot and want all data on the contact record, this may be the
                        right
                        choice
                        for you.
                        </p>
                    </mat-radio-button>
                </div>
                <div class="mt-4">
                    <mat-radio-button name="integrationVersion" id="hubspotCrm" value="hubspotCrm">
                        <p class="word-break mb-0">
                        <b>HubSpot CRM</b> - Sync contact and company records simultaneously to HubSpot. Your contact
                        records will
                        live under the corresponding company record. If you use HubSpot as your CRM of record or if you
                        use
                        the
                        "Companies" object in HubSpot, this may be the right choice for you.
                        </p>
                    </mat-radio-button>
                </div>
            </mat-radio-group>
        </div>
    </ng-template>
    <ng-template appDialogFooter>
        <button matButton="outlined" type="button" (click)="modalComponent.onClose()">Cancel</button>
        <button matButton="filled" type="button" [disabled]="!selectedOption"
            (click)="proceed(modalComponent)">Connect</button>
    </ng-template>
</app-si-dialog>
